import { apiRequest } from '../../lib/api';
import {
  eventArchiveResultSchema,
  eventMutationResultSchema,
  eventSchema,
  eventsSchema,
  eventToggleResultSchema,
  zoomConnectionStatusSchema,
} from '../../lib/schemas';
import type { EventSummary, ZoomConnectionStatus } from '../../types';

export interface EventCreateInput {
  zoom_account: number;
  event_type: 'meeting' | 'webinar';
  zoom_id: string;
  topic?: string;
  room_name?: string;
  team_shared: boolean;
  scheduled_at?: number;
}

export interface EventUpdateInput {
  topic: string;
  room_name: string;
  zoom_id: string;
  zoom_account: number;
  event_type: 'meeting' | 'webinar';
}

export type EventStyleInput = Partial<Pick<EventSummary,
  'color' | 'room_name' | 'is_vip' | 'join_url' | 'bot_enabled' | 'bot_name' | 'team_shared' | 'scheduled_at'
>>;

export function getEvents(signal?: AbortSignal): Promise<EventSummary[]> {
  return apiRequest('/api/events', eventsSchema, signal ? { signal } : {});
}

export function createEvent(input: EventCreateInput) {
  return apiRequest('/api/events', eventMutationResultSchema, { method: 'POST', body: JSON.stringify(input) });
}

export function updateEvent(eventId: number, input: EventUpdateInput) {
  return apiRequest(`/api/events/${eventId}/update`, eventMutationResultSchema, { method: 'POST', body: JSON.stringify(input) });
}

export function styleEvent(eventId: number, input: EventStyleInput) {
  return apiRequest(`/api/events/${eventId}/style`, eventSchema, { method: 'POST', body: JSON.stringify(input) });
}

export function verifyEvent(eventId: number) {
  return apiRequest(`/api/events/${eventId}/verify`, eventMutationResultSchema, { method: 'POST' });
}

export function toggleEvent(eventId: number) {
  return apiRequest(`/api/events/${eventId}/toggle`, eventToggleResultSchema, { method: 'POST' });
}

export function archiveEvent(eventId: number) {
  return apiRequest(`/api/events/${eventId}/delete`, eventArchiveResultSchema, { method: 'POST' });
}

export function getZoomConnectionStatus(signal?: AbortSignal): Promise<ZoomConnectionStatus> {
  return apiRequest('/api/zoom/status', zoomConnectionStatusSchema, signal ? { signal } : {});
}
